export class Parent {
    get id() {
        return this.parentState.id;
    }
    get idThird() {
        return this.parentState.idThird;
    }
    get nameThird() {
        return this.parentState.nameThird;
    }
    get idThirdReturn() {
        return this.parentState.idThirdReturn;
    }
    get nameThirdReturn() {
        return this.parentState.nameThirdReturn;
    }
    get idKinship() {
        return this.parentState.idKinship;
    }
    get nameKinship() {
        return this.parentState.nameKinship;
    }
    set id(id) {
        this.parentState.id = id;
    }
    set idThird(idThird) {
        this.parentState.idThird = idThird;
    }
    set nameThird(nameThird) {
        this.parentState.nameThird = nameThird;
    }
    set idThirdReturn(idThirdReturn) {
        this.parentState.idThirdReturn = idThirdReturn;
    }
    set nameThirdReturn(nameThirdReturn) {
        this.parentState.nameThirdReturn = nameThirdReturn;
    }
    set idKinship(idKinship) {
        this.parentState.idKinship = idKinship;
    }
    set nameKinship(nameKinship) {
        this.parentState.nameKinship = nameKinship;
    }
    constructor(parentState) {
        this.parentState = parentState;
    }
    getState() {
        return this.parentState;
    }
}
